const config = {
  appVersion: '1.2.1',
  localApiHost: 'https://api-admin.diagmatic.pl',
  apiUrl: 'api',
  debounceTime: 300,
};

export default config;
